import axios from "axios";
import http from "../assets/extra/_httpServices";
import { urls } from "../components/common/constants";
import actionTypes from "./ActionTypes";

export const logIn = (url, body) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            http.HttpCall(url, "post", {}, body)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    if (response.status === 200 && response.data.Status == "true") {
                        dispatch(getServerTime(response.data.Data.token))
                        localStorage.setItem("token", response.data.Data.token);
                        sessionStorage.setItem("token", response.data.Data.token);
                        const data = {
                            IsMTPLAdmin: response.data.Data.IsMTPLAdmin,
                            IsAdmin: response.data.Data.IsAdmin,
                            IsBranchAdmin: response.data.Data.IsBranchAdmin,
                            CompanyID: response.data.Data.intCompanyID,
                            UserID: response.data.Data.intUserID,
                            CountryID: response.data.Data.intCountryID,
                            BranchName: response.data.Data.strBranchName,
                            CompanyName: response.data.Data.strCompanyName,
                            UserName: response.data.Data.strUserName,
                            RoleID: response.data.Data.intRoleID,
                            BranchID: response.data.Data.intBranchID,
                            CityID: response.data.Data.intBranchCityID,
                            StateID: response.data.Data.intBranchStateID,
                            MultiplePayments: response.data.Data.IsMultiplePaymentMethodsForAVEnabled,
                            MobileLowerLimit: response.data.Data.MobileNoLLimit,
                            MobileUpperLimit: response.data.Data.MobileNoULimit,
                            AccountingProductId: response.data.Data.AccountingProductId,
                            IsCollBoyRequestPayment: response.data.Data.IsCollBoyRequestPayment,
                            isSTACompanyID: response.data.Data.isSTACompanyID,
                            CounterID: response.data.Data.CounterID,
                            ADV_RESERV_DAYS: response?.data?.Data2?.Table3?.[0]?.ADV_RESERV_DAYS
                            // intLogID
                        }
                        let agents = false, agentVoucher = false, agentRecharge = false;
                        let agentRightData = response.data.Data2.Table1;
                        if (agentRightData.length > 0) {
                            let ar = agentRightData.filter((ele) => ele.JobID === 20 && (data.IsAdmin === 1 || data.IsBranchAdmin === 1 || data.IsMTPLAdmin === 1 ? true : ele.IsActive === 1))
                            agents = ar.length > 0 ? true : false;
                            let avr = agentRightData.filter((ele) => (ele.JobID === 39 || ele.JobID === 40) && (data.IsAdmin === 1 || data.IsBranchAdmin === 1 || data.IsMTPLAdmin === 1 ? true : ele.IsActive === 1))
                            agentVoucher = avr.length > 0 ? true : false;
                            let arr = agentRightData.filter((ele) => ele.JobID === 74 && (data.IsAdmin === 1 || data.IsBranchAdmin === 1 || data.IsMTPLAdmin === 1 ? true : ele.IsActive === 1))
                            agentRecharge = arr.length > 0 ? true : false;
                        }
                        const agentRight = {
                            agents: agents,
                            agentVoucher: agentVoucher,
                            agentRecharge: agentRecharge,
                        }

                        sessionStorage.setItem("userData", JSON.stringify(data));
                        sessionStorage.setItem("agentRight", JSON.stringify(agentRight));
                        sessionStorage.setItem("loginData", JSON.stringify(response.data.Data));
                        // sessionStorage.setItem("roleData", JSON.stringify(response.data.Data));
                        dispatch(log_in(data, agentRight));
                        dispatch(loginData(response.data.Data))
                        dispatch(roleData(response.data.Data2.Table1))
                        return resolve(response.data);
                    }
                    else {
                        return resolve(response.data);
                    }
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    return reject(error);
                })
        })
    }
}

export const sendOneDayPassword = (url, body) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http
                .HttpGet(url, body)
                .then((response) => {
                    dispatch(updateLoadingScreen(false))
                    return resolve(response);
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false))
                    console.log("Error: ", error);
                });
        });
    };
};
export const sendPasswordUrl = (url, body) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http
                .HttpGet(url, body)
                .then((response) => {
                    dispatch(updateLoadingScreen(false))
                    return resolve(response);
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false))
                    console.log("Error: ", error);
                });
        });
    };
};

export const setLoginPassword = (url, body) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http.HttpCall(url, "post", {}, body)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const updateLoading = (data) => {
    return {
        type: actionTypes.UPDATE_LOADING,
        payload: data,
    }
}

export const updateLoadingScreen = (data) => {
    return {
        type: actionTypes.UPDATE_LOADING_SCREEN,
        payload: data,
    }
}

export const log_in = (data, agentRight) => {
    return {
        type: actionTypes.LOG_IN,
        payload: data,
        agentRight: agentRight,
    }
}
export const loginData = (data) => {
    return {
        type: actionTypes.LOGIN_DATA,
        payload: data,
    }
}
export const updateUserData = (data) => {
    return {
        type: actionTypes.UPDATE_USER_DATA,
        payload: data,
    }
}
export const roleData = (data) => {
    sessionStorage.setItem("roleData", JSON.stringify(data));
    return {
        type: actionTypes.ROLE_DATA,
        payload: data,
    }
}
export const menuVisible = () => {
    return {
        type: actionTypes.MENU_VISIBLE,
    }
}
export const mainMenuVisible = (data) => {
    return {
        type: actionTypes.MAIN_MENU,
        payload: data,
    }
}
export const serviceMasterMenuVSBL = (data) => {
    return {
        type: actionTypes.SERVICE_MASTER_MENU,
        payload: data,
    }
}
export const stockManagementMenuVSBL = (data) => {
    return {
        type: actionTypes.STOCK_MANAGEMENT_MENU,
        payload: data,
    }
}
export const othersMenuVSBL = (data) => {
    return {
        type: actionTypes.OTHERS_MENU,
        payload: data,
    }
}
export const routeMenuVSBL = (data) => {
    return {
        type: actionTypes.ROUTE_MENU,
        payload: data,
    }
}
export const casualContractMenuVSBL = (data) => {
    return {
        type: actionTypes.CASUAL_CONTRACT_MENU,
        payload: data,
    }
}
export const userConfigMenuVSBL = (data) => {
    return {
        type: actionTypes.USER_CONFIG_MENU,
        payload: data,
    }
}
export const cargoRateMenuVSBL = (data) => ({
    type: actionTypes.CARGO_RATE_CONFIG,
    payload: data,
});


export const layoutConfigVSBL = (data) => {
    return {
        type: actionTypes.LAYOUT_CONFIG_MENU,
        payload: data,
    }
}

export const fareConfigVSBL = (data) => {
    return {
        type: actionTypes.FARE_CONFIG_MENU,
        payload: data,
    }
}
export const masterConfigMenuVSBL = (data) => {
    return {
        type: actionTypes.MASTER_CONFIG_MENU,
        payload: data,
    }
}
export const bookingMenu = (data) => {
    return {
        type: actionTypes.BOOKING_MENU,
        payload: data,
    }
}
export const KSDTCBookingMenu = (data) => {
    return {
        type: actionTypes.KSDTC_BOOKING_MENU,
        payload: data,
    }
}
export const logout = () => {
    return {
        type: actionTypes.LOGOUT,
    }
}

export const reportMenu = (data) => {
    return {
        type: actionTypes.REPORT_MENU,
        payload: data,
    }
}
export const casualContractReportMenu = (data) => {
    return {
        type: actionTypes.CASUAL_CONTRACT_REPORT_MENU,
        payload: data,
    }
}
export const generalReportMenu = (data) => {
    return {
        type: actionTypes.GENERAL_REPORT_MENU,
        payload: data,
    }
}
export const accountsReportMenu = (data) => {
    return {
        type: actionTypes.ACCOUNTS_REPORT_MENU,
        payload: data,
    }
}
export const onlineReportMenu = (data) => {
    return {
        type: actionTypes.ONLINE_REPORT_MENU,
        payload: data,
    }
}
export const otherReportMenu = (data) => {
    return {
        type: actionTypes.OTHER_REPORT_MENU,
        payload: data,
    }
}
export const cargoReportsMenu = (data) => {
    return {
        type: actionTypes.CARGO_REPORT_MENU,
        payload: data,
    }
}
export const pprManagementsMenu = (data) => {
    return {
        type: actionTypes.PPR_MANAGEMENT_MENU,
        payload: data,
    }
}
export const kstdcReportMenu = (data) => {
    return {
        type: actionTypes.KSTDC_REPORT_MENU,
        payload: data,
    }
}
export const UpdateIpAddress = (data) => {
    return {
        type: actionTypes.UPDATE_IP_ADDRESS,
        payload: data,
    }
}

export const cargoMenu = (data) => {
    return {
        type: actionTypes.CARGO_MENU,
        payload: data,
    }
}
export const logoutUser = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpCall(urls.logoutUser, "post", {}, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export const masterCodeAllValue = (data) => {
    return {
        type: actionTypes.MASTER_CODE_ALLVALUE,
        payload: data,
    }
}

export const UpdateComplaintManagement = (data) => {
    return {
        type: actionTypes.COMPLAINT_MANAGEMENT,
        payload: data,
    }
}

export const updateRevokeAndSeriveDate = (data) => {
    return {
        type: actionTypes.UPDATE_REVOKE_SERIVE_DATE,
        payload: data,
    }
}
export const LoginV3 = (url, body) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http.HttpCall(url, "post", {}, body)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const cargoReportMainMenu1 = (data) => {
    return {
        type: actionTypes.CARGO_REPORT_MAIN_MENU,
        payload: data,
    }
}
export const cargoDCReportMenu1 = (data) => {
    return {
        type: actionTypes.CARGO_DC_REPORT_MENU,
        payload: data,
    }
}
export const cargoDashboardReportMenu1 = (data) => {
    return {
        type: actionTypes.CARGO_DASHBOARD_REPORT_MENU,
        payload: data,
    }
}
export const cargoOperationsReportsMenu1 = (data) => {
    return {
        type: actionTypes.CARGO_OPERATIONS_REPORT_MENU,
        payload: data,
    }
}
export const cargoAccountsReportsMenu1 = (data) => {
    return {
        type: actionTypes.CARGO_ACCOUNTS_REPORT_MENU,
        payload: data,
    }
}
export const setCounterId = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpCall(urls.setCounterId, "post", {}, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export const getServerTime = (logintoken = null) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            http
                .HttpGet('/Common/GetServerTime', {}, logintoken)
                .then((response) => {
                    let seriveTime = new Date(response?.data)
                    let localTime = new Date()
                    let diff = seriveTime?.valueOf() - localTime?.valueOf()
                    sessionStorage.setItem('timeConfig', JSON.stringify({ seriveTime, localTime, diff }))
                    return resolve(response);
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    reject(error);
                });
        })
    };
};
